
<div class="modal fade" :id="elementId" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ heading }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{ message }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                        @click="onYesClick">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>
